<script>
    import MenuRow from "./MenuRow.svelte";
    import {menuRows} from "../../content/static/menu";
    import {createEventDispatcher} from "svelte";
    import {fly, fade} from "svelte/transition";
    import Logo from "../Logo.svelte";
    import {push} from "svelte-spa-router";
    import {_} from "svelte-i18n";

    let openMenu = true;

    let dispatch = createEventDispatcher();
    export let flyAnimation;
    export let desktopAnimation = false;

    function closeClicked() {
        dispatch("closeClicked");
        openMenu = false;
    }

    addEventListener("keydown", (event) => {
        const key = event.key;
        if (key === "Escape") {
            closeClicked();
        }
    });
</script>

<div
        class="menu blur"
        in:fade={desktopAnimation
        ? { x: 624, duration: flyAnimation, opacity: 1 }
        : { y: 812, duration: flyAnimation, opacity: 1 }}
        out:fade={!openMenu
        ? desktopAnimation
            ? { x: 624, duration: flyAnimation, opacity: 1 }
            : { y: 812, duration: flyAnimation, opacity: 1 }
        : desktopAnimation
        ? { x: 0, duration: flyAnimation, opacity: 1 }
        : { y: 0, duration: flyAnimation, opacity: 1 }}
>
    <div class="menu-wrapper">
        <div class="menu-left disp-big" on:click={closeClicked}/>
        <div class="divider-v disp-big"/>
        <div class="menu-right">
            <div style="display:flex; justify-content:right; height:76px;">
                <div class="close icon" on:click={closeClicked}>
                    <svg
                            width="32"
                            height="32"
                            viewBox="0 0 32 32"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                    >
                        <circle cx="16" cy="16" r="15.5" stroke="#1A1A17"/>
                        <path d="M9 9L23 23" stroke="#1A1A17"/>
                        <path d="M23 9L9.00001 23" stroke="#1A1A17"/>
                    </svg>
                </div>
            </div>
            <div class="headline-m allgemeines">{$_("general")}</div>
            <div class="menu-rows">
                {#each $menuRows as menuRow, index}
                    <MenuRow {menuRow} externalLink={menuRow.externalLink}/>
                    {#if index < $menuRows.length - 1}
                        <div
                                class="divider-v disp-small"
                                style="height: 421px;"
                        />
                        <div
                                class="divider-v disp-big"
                                style="margin: 0 24px;"
                        />
                    {/if}
                {/each}
            </div>
        </div>
    </div>
</div>

<style>
    .menu-wrapper {
        height: 100vh;
        width: 100vw;
        /*background: var(--white-64);*/
        -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
        -moz-box-sizing: border-box; /* Firefox, other Gecko */
        box-sizing: border-box;
    }

    .menu-rows {
        padding-bottom: 41px;
        padding-top: 42px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-left: 16px;
        margin-right: 16px;
    }

    .menu {
        position: fixed;
        z-index: 2;
        overflow-y: scroll;
    }

    .allgemeines {
        margin-left: 16px;
        margin-right: 16px;
    }

    .close {
        margin: 24px 24px 0 0;
    }

    .disp-big {
        display: none;
    }

    .blur {
        -webkit-backdrop-filter: blur(24px);
        backdrop-filter: blur(24px);
        background: var(--white-64);
    }

    .headline-xs-custom {
        font-family: "Trade Gothic LT Std", sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 18px;
        line-height: 96%;
        /* or 19px */
        letter-spacing: -0.02em;

        text-transform: uppercase;

        color: var(--black-100);
    }

    @media only screen and (min-width: 799px) {
        .menu-wrapper {
            display: flex;
            flex-direction: row;
        }

        .menu-rows {
            padding-right: 40px;
            padding-left: 40px;
        }

        .menu-left {
            display: flex;
            flex-direction: column;
            flex-basis: 58%;
        }

        .menu-right {
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            -webkit-backdrop-filter: blur(24px);
            backdrop-filter: blur(24px);
            background: var(--white-64);
            overflow-y: auto;
        }

        .allgemeines {
            display: none;
        }

        .close {
            margin: 23px 32px 0 0;
        }

        .disp-small {
            display: none;
        }

        .disp-big {
            display: flex;
        }

        .blur {
            -webkit-backdrop-filter: unset;
            backdrop-filter: unset;
            background: unset;
        }

        .menu {
            overflow-y: unset;
        }
    }
</style>
